/**
 * AdsSectionFilters — фильтры раздела «Реклама» над вкладками
 * ============================================================
 *
 * Платформа (общий фильтр дашборда, см. AdsPlatformToggle) и страны (выбор
 * раздела, см. hooks/useAdsGeo). Оба действуют на все вкладки раздела.
 */

import React from 'react';
import { useAdsGeo } from '../../../hooks/useAdsGeo';
import { RetentionGeoFilter } from '../RetentionGeoFilter';
import { AdsPlatformToggle } from './AdsPlatformToggle';

export function AdsSectionFilters() {
  const { geos, toggleGeo, clearGeos, maxGeos } = useAdsGeo();

  return (
    <div className="flex flex-wrap items-center justify-end gap-3 mb-3">
      <RetentionGeoFilter geos={geos} onToggleGeo={toggleGeo} onClearGeos={clearGeos} maxGeos={maxGeos} />
      <AdsPlatformToggle />
    </div>
  );
}

export default AdsSectionFilters;
